<template>
  <div style="height: 100%;">
    <div style="margin-bottom: 8px;text-align: right;">
      <a-button v-tc="{ name: '新增部门' }" @click="openAdd">
        新增部门
      </a-button>
    </div>
    <div class="content">
      <a-table :bordered="true" :pagination="false" size="small" :data-source="dataList">
        <a-table-column title="ID" width="100px">
          <template slot-scope="text, record">
            <a-input-number v-if="record.isEdit" v-model="record.value" placeholder="请输入ID" />
            <span v-else>
              {{ record.value }}
            </span>
          </template>
        </a-table-column>
        <a-table-column title="名称">
          <template slot-scope="text, record">
            <a-input v-if="record.isEdit" v-model="record.label" placeholder="" />
            <span v-else>
              {{ record.label }}
            </span>
          </template>
        </a-table-column>
        <a-table-column title="颜色">
          <template slot-scope="text, record">
            <a-input v-if="record.isEdit" v-model="record.color" placeholder="" />
            <span v-else>
              {{ record.color }}
            </span>
          </template>
        </a-table-column>
        <a-table-column width="150px" title="操作">
          <template slot-scope="record">
            <a-button v-if="record.isEdit" size="small" type="link" @click="saveRow(record)">
              保存
            </a-button>
            <a-button size="small" type="link" @click="editRow(record)">
              编辑
            </a-button>
            <a-popconfirm
              title="确定删除这条数据?"
              ok-text="是"
              cancel-text="否"
              @confirm="delRow(record)"
            >
              <a-button v-tc="{ name: '删除' }" size="small" type="link">
                删除
              </a-button>
            </a-popconfirm>
          </template>
        </a-table-column>
      </a-table>
    </div>

    <AddOrEdit ref="addOrEditRef" :data-list="dataList" :selected-key="selectedKey" />
  </div>
</template>

<script>
import { modifyTicketConfig } from '@/api/event/problem';
import AddOrEdit from './AddOrEdit.vue';
export default {
  components: {
    AddOrEdit
  },
  props: {
    selectedKey: {
      type: String,
      default: ''
    },
    selectedValue: {}
  },
  data() {
    return {
      dataList: []
    };
  },
  watch: {
    selectedValue: {
      handler() {
        // {fs_user_id: "95353ed3",nickname: "徐乾彭"user_id:735}
        this.dataList = this.selectedValue || [];
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    saveRow(record) {
      if (!record.label || !record.value || !record.color) {
        this.$message.error('请填写完整信息');
        return;
      }
      this.$delete(record, 'isEdit');
      this.updateData(this.selectedKey, this.dataList || []);
    },
    editRow(record) {
      this.$set(record, 'isEdit', true);
    },
    delRow(record) {
      this.dataList = this.dataList.filter(item => item.value !== record.value);
      console.log(record);
      this.updateData();
    },
    openAdd() {
      const maxValue = Math.max(...this.dataList.map(item => item.value));
      this.dataList.push({ 'label': '名称', 'value': maxValue + 1, 'color': 'cyan', isEdit: true });
      // this.$refs.addOrEditRef.open();
    },
    updateData() {
      modifyTicketConfig({
        info: this.dataList || [],
        number: this.selectedKey
      })
        .then(res => {
          this.$message.success('保存成功');
          this.$store.dispatch('getGlobalConfigList');
        })
        .catch(() => {
        });
    }
  }
};
</script>

<style lang="less" scoped>

</style>
